<!-- START CONTENT -->
<section>
  <div class="col-xs-12">
    <section class="box">
      <div class="content-body">
        <div style="display: block">
          <canvas baseChart height="400"
                  [datasets]="lineChartData"
                  [options]="lineChartOptions"
                  [chartType]="lineChartType">
          </canvas>
        </div>
        </div>
      </section>
    <div class="row">
      <div class="col-xs-2">
        <div class="form-group">
          <label class="form-label">Start</label>
          <div class="controls">
            <input type="date" class="form-control" [(ngModel)]="fromDate" name="fromDate"/>
          </div>
        </div>
      </div>
      <div class="col-xs-2">
        <div class="form-group">
          <label class="form-label">End</label>
          <div class="controls">
            <input type="date" class="form-control" [(ngModel)]="toDate" name="toDate"/>
          </div>
        </div>
      </div>
      <div class="col-xs-2">
        <div class="form-group">
          <label class="form-label">&nbsp;</label>
          <div class="controls">
            <button class="form-control" (click)="dateChanged($event)">Update</button>
          </div>
        </div>
      </div>
    </div>
    </div>
  </section>
